import { useState, useEffect, useMemo } from "react";
import RightOverlay from "../../components/RightOverlay/RightOverlay";
import ShowTickets from "./ShowTickets";
import { AgGridReact } from "ag-grid-react";
import { Spinner } from "react-bootstrap";
import useApi from "../../helpers/api";
import Navigation from "../../components/Navigation/Navigation.js";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation.js"

// Importar estilos de AG Grid
export default function MyAgGridTable() {
  const [data, setData] = useState([]);
  const [cliente, setCliente] = useState();
  const [dni, setDni] = useState();
  const [cp, setCp] = useState();
  const [direccion, setDireccion] = useState();
  const [telefono, setTelefono] = useState();
  const [provincia, setProvincia] = useState();
  const [ciudad, setCiudad] = useState();
  const [email, setEmail] = useState();
  const [update, setUpdate] = useState(true);
  const [loading, setLoading] = useState(true);
  const [overlayEditShow, setOverlayEditShow] = useState(false);
  const [IdEdit, setIdEdit] = useState(null);
  const api = useApi();

  useEffect(() => {
    setLoading(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update]);

  const fetchData = async () => {
    try {
      const response = await api.getComprasInforme(localStorage.getItem("token"));
      formatData(response.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const formatData = (data) => {
    for (let transaction of data) {
      transaction.cliente = `${transaction.nombre} ${transaction.apellido}`;
    }
    setData(data);
  };

  const overlayShowHide = () => {
    setOverlayEditShow(false);
    setIdEdit(null);
  };

  const showTickets = (
    id,
    cliente,
    dni,
    provincia,
    ciudad,
    email,
    cp,
    direccion,
    telefono
  ) => {
    setOverlayEditShow(true);
    setIdEdit(id);
    setCliente(cliente);
    setDni(dni);
    setProvincia(provincia);
    setCiudad(ciudad);
    setEmail(email);
    setCp(cp);
    setDireccion(direccion);
    setTelefono(telefono);
  };

  const refresh = () => {
    setUpdate(!update);
  };

  // Definición de columnas
  const columnDefs = useMemo(
    () => [
      { field: "id", headerName: "Id", sortable: true, filter: true },
      { field: "order_id", headerName: "Id woo", sortable: true, filter: true },
      { field: "email", headerName: "Email", sortable: true, filter: true },
      { field: "cliente", headerName: "Cliente", sortable: true, filter: true },
      { field: "dni", headerName: "DNI", sortable: true, filter: true },
      { field: "formatMonto", headerName: "Monto", sortable: true, filter: true },
      { field: "estado", headerName: "Estado", sortable: true, filter: true },
      { field: "fecha", headerName: "Fecha", sortable: true, filter: true },
      {
        headerName: "Entradas",
        cellRenderer: (params) => (
          <button
            className="btn btn-primary mb-2"
            onClick={() =>
              showTickets(
                params.data.id,
                params.data.cliente,
                params.data.dni,
                params.data.provincia,
                params.data.ciudad,
                params.data.email,
                params.data.cp,
                params.data.direccion,
                params.data.telefono
              )
            }
          >
            Ver
          </button>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Compras" />
      <RightOverlay
        id={IdEdit}
        overlayContent={ShowTickets}
        overlayShowHide={overlayShowHide}
        overlayShow={overlayEditShow}
        cliente={{
          nombre: cliente,
          dni: dni,
          provincia: provincia,
          ciudad: ciudad,
          email: email,
          cp: cp,
          direccion: direccion,
          telefono: telefono,
        }}
      />
      

      <div
        className="ag-theme-alpine container"
        style={{ height: 500, width: "100%" }}
      >
        <div className="w-100 d-flex justify-content-end">
          <div>
            <button className="btn btn-primary my-2 mx-4" onClick={refresh}>
              Actualizar
            </button>
          </div>
        </div>
        {loading ? (
          <div className="w-100 d-flex justify-content-center mb-4">
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </div>
        ) : (
          <AgGridReact
            rowData={data}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={10}
            defaultColDef={{
              resizable: true,
              sortable: true,
              filter: true,
              flex: 1,
              minWidth: 100,
            }}
          />
        )}
      </div>
    </>
  );
}
